import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";

import Isvg from "react-inlinesvg";
import { Calendar } from "react-date-range";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import * as locales from "react-date-range/dist/locale";
import { DOMAINS } from "../../../constants";
import moment from "moment";

function getMaxDaysInCurrentMonth(value) {
  const currentDate = new Date(value);
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth(); // trenutni mesec

  // Postavlja datum na poslednji dan trenutnog meseca
  const date = new Date(year, month + 1, 0);
  return date.getDate(); // Vraća broj dana u tom mesecu
}
function iosDevice() {
  //return true;
  var userAgent = window.navigator.userAgent;
  if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
    return true;
  } else {
    return false;
  }
}
function formatDateAndGetWeek(dateStr, lang) {
  // Helper function to get the week number
  function getWeekNumber(date) {
    if (date && date !== NaN) {
      date = new Date(date);
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() - 1);
      const m = moment(date);
      const week = m.week();
      return week;
    } else {
      return null;
    }
  }

  let date;
  // Try parsing MM-DD-YYYY
  if (dateStr.match(/^\d{2}-\d{2}-\d{4}$/)) {
    const [month, day, year] = dateStr.split("-");
    date = new Date(`${year}-${month}-${day}`);
  }
  // Try parsing YYYY-MM-DD
  else if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
    date = new Date(dateStr);
  } else {
    throw new Error("Invalid date format. Use MM-DD-YYYY or YYYY-MM-DD.");
  }

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date.");
  }

  // Format the date
  const options = { weekday: "long", month: "short", day: "numeric" };
  const locale = lang === 'se' ? 'sv-SE' : 'en-US';
  const formattedDate = date.toLocaleDateString(locale, options);

  // Get the week number
  const weekNumber = getWeekNumber(date);

  return {
    formattedDate,
    weekNumber: `${'v.'.translate(lang)} ${weekNumber}`
  };
}



/**
 * Custom datepicker
 * @author   Stefan Pantic
 */
class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();

    this.state = {};
  }

  componentDidMount() {
    let date = new Date();

    this.setState({
      year: date.getFullYear(),
    });

    if (this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }

    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value != this.state.value && !this.state.value) {
      if (this.props.value) {
        this.setState({
          value: this.props.value,
        });
      }
    }
    if (this.state.showCalendar && prevState.showCalendar != this.state.showCalendar) {
      this.calculateWeekNumbersCalendar();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({
        showCalendar: null,
      });
    }
  };

  clearCustomElements = () => {
    if (typeof window === 'undefined') return;
    let elementsForRemove = document.getElementsByClassName("rdrWeekDayWeekNumberLabel");
    while (elementsForRemove.length > 0) {
      elementsForRemove[0].parentNode.removeChild(elementsForRemove[0]);
    }
    elementsForRemove = document.getElementsByClassName("rdrWeekNumber");
    while (elementsForRemove.length > 0) {
      elementsForRemove[0].parentNode.removeChild(elementsForRemove[0]);
    }
  }
  calculateWeekNumberByDate = (dateStr) => {
    if (dateStr && dateStr !== NaN) {
      let date = new Date(dateStr);
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() - 1);
      const m = moment(date);
      const week = m.week();
      return week && week !== NaN ? week : null;
    } else {
      return null;
    }
  }

  calculateWeekNumbersCalendar = (number = 0) => {
    if (this.state.showCalendar) {
      if (typeof window === 'undefined') return;

      this.clearCustomElements();

      const weekDays = document.getElementsByClassName("rdrWeekDays");
      const days = document.getElementsByClassName("rdrDays");
      const newArray = days?.[0]?.children ?? [];

      if (this.dateArr?.length === newArray.length && newArray.length > 0) {
        if (weekDays) {
          for (let i = 0; i < weekDays.length; i++) {
            let weekNumber = document.createElement("span");
            weekNumber.className = "rdrWeekDayWeekNumberLabel";
            weekNumber.innerHTML = `v`.translate(this.props.lang);
            weekDays[i].insertBefore(weekNumber, weekDays[i].childNodes[0]);
          }
          let rdrWeekDay = document.getElementsByClassName("rdrWeekDay");
          for (let i = 0; i < rdrWeekDay?.length; i++) {
            rdrWeekDay[i]?.style?.setProperty("flex-basis", "calc(100% / 8)", "important");
          }
        }

        if (newArray.length > 0) {

          for (let i = 0; i < newArray.length; i++) {
            if (i === 0 || i % 8 === 0) {
              let element = document.createElement("div");
              element.className = "rdrWeekNumber";
              element.innerHTML = this.calculateWeekNumberByDate(this.dateArr[i]) ?? '';
              days?.[0]?.insertBefore?.(element, newArray[i]);
            }
          }
          let rdrDay = document.getElementsByClassName("rdrDay");
          for (let i = 0; i < rdrDay?.length; i++) {
            rdrDay[i]?.style?.setProperty("width", "calc(100% / 8)", "important");
          }
        }
      } else {
        if (number > 10) return;
        setTimeout(() => {
          this.calculateWeekNumbersCalendar(number + 1);
        }, 20 * number + 10);
      }
    }
  }
  render() {
    let locale = null;

    if (typeof window !== "undefined" && iosDevice() && false) {
      locale = undefined;
    } else if (typeof window !== "undefined" && window._lang) {
      if (window._lang == "en") {
        locale = locales.enGB;
      } else {
        let domen = window.location.origin;
        let country = DOMAINS.find((item) => item.domen == domen)?.country;
        if (country == "sweden") {
          locale = locales.sv;
        } else if (country == "denmark") {
          locale = locales.da;
        } else if (country == "gr") {
          locale = locales.el;
        } else if (country == "es") {
          locale = locales.es;
        } else if (country == "ch") {
          locale = locales.de;
        } else {
          locale = locales.enGB;
        }
      }
    }
    let value = this.props.value;
    let { formattedDate, weekNumber } = formatDateAndGetWeek(value, this.props.lang)
    if (formattedDate)
      value = formattedDate;


    return (
      <div
        className={
          this.props.error
            ? "date-picker-field-prev-next-v2 required"
            : "date-picker-field-prev-next-v2"
        }
        ref={this.wrapperRef}
      >
        <label>{this.props.label}</label>
        <div style={{ display: "flex", position: "relative", justifyContent: 'flex-end' }}>
          <div
            className="prev-button"
            onClick={() => {
              let day = new Date(this.props.value.replace(/-/g, "/"));
              day.setDate(day.getDate() - 1);
              this.props.onChange(
                moment(day).format(
                  this.props.dateFormat ? this.props.dateFormat : "YYYY-MM-DD"
                )
              );
            }}
          >
            {"Previous".translate(this.props.lang)}
          </div>
          <div className="date-picker-whole-clinic-input-wrap">
            {
              weekNumber ? <div className="week-number-whole-clinic">{weekNumber}</div> : null
            }
            <input
              value={value}
              type="text"
              onFocus={() => {
                if (!this.state.showCalendar) {
                  this.setState({
                    showCalendar: true,
                  });
                }
              }}
            />
          </div>
          <div
            className="next-button"
            onClick={() => {
              let day = new Date(this.props.value.replace(/-/g, "/"));
              day.setDate(day.getDate() + 1);
              this.props.onChange(
                moment(day).format(
                  this.props.dateFormat ? this.props.dateFormat : "YYYY-MM-DD"
                )
              );
            }}
          >
            {"Next".translate(this.props.lang)}
          </div>
        </div>

        {this.state.showCalendar ? (
          <div className="calendar-date-picker-wrap">
            <Calendar
              minDate={
                this.props.endDate
                  ? this.props.endDate
                  : this.props.minDate
                    ? this.props.minDate
                    : new Date(1990, 1 - 1)
              }
              maxDate={this.props.maxDate}
              // maxDate={new Date(this.state.year, 11, 31)}
              date={
                this.props.value
                  ? new Date(this.props.value.replace(/-/g, "/"))
                  : this.state.date
              }
              locale={locale}
              // navigatorRenderer={(date, fun, obj) => {
              //   console.log(date, obj);
              // }}
              // // showMonthAndYearPickers={true}
              // // editableDateInputs={true}
              // // dayContentRenderer={(date) => {
              // //   console.log('dayContentRenderer', date);
              // //   return `v1. ${date.getDate()}`;
              // }}
              dayContentRenderer={(date) => {
                if (date) {
                  let dateStr = moment.unix(new Date(date).getTime() / 1000).format('MM/DD/YYYY');
                  let dateArr = this.dateArr?.length ? this.dateArr : [];
                  if (!dateArr.includes(dateStr)) {
                    dateArr.push(dateStr);
                    this.dateArr = dateArr;
                  }
                }
              }}

              onShownDateChange={(date) => {
                this.dateArr = [];
                this.calculateWeekNumbersCalendar();
                let d = new Date(date);
                if (this.props.value) {
                  const daysInMonth = getMaxDaysInCurrentMonth(date);
                  let currentDate = new Date(this.props.value.replace(/-/g, "/")).getDate();
                  let dateValue = currentDate > daysInMonth ? daysInMonth : currentDate;
                  d.setDate(
                    dateValue
                  );
                }

                this.props.onChange(
                  moment(d).format(
                    this.props.dateFormat ? this.props.dateFormat : "YYYY-MM-DD"
                  )
                );
              }}
              onChange={(date) => {
                this.setState(
                  {
                    showCalendar: null,
                    // value:moment(new Date(date)).format('YYYY-MM-DD')
                  },
                  () => {
                    // if(typeof window != 'undefined'){
                    //     window.stopVerifyFun = false
                    // }
                  }
                );
                this.props.onChange(
                  moment(new Date(date)).format(
                    this.props.dateFormat ? this.props.dateFormat : "YYYY-MM-DD"
                  )
                );
                if (this.props.openCalendar) this.props.closeCalendar();
              }}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default DatePicker;
